import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { AboutusComponent } from './aboutus/aboutus.component';
import { ProductsComponent } from './products/products.component';
import { ContactComponent } from './contact/contact.component';
import { AdvertisingComponent } from './advertising/advertising.component';

/*
const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'about_us', component: AboutusComponent },
  { path: 'products', component: ProductsComponent },
  { path: 'contact', component: ContactComponent },
  { path: 'advertising', component: AdvertisingComponent},
  { path: '**', pathMatch: 'full', redirectTo: '' }
];
*/

const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'advertising', component: AdvertisingComponent},
  { path: 'contact', component: ContactComponent },
  { path: '**', pathMatch: 'full', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{
    scrollPositionRestoration: 'enabled'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }